import React, { useEffect } from 'react';
import { useFormatData, useSearchData } from 'lib/hook';
import Table from '../table';

const DataTable = React.forwardRef((props, ref) => {
    const {
        bordered = false,
        pageLength,
        columns,
        data,
        searchText,
        rowKey,
        currentRow,
        onSelectRow,
        initCurrentRow = true,
        renderColumns,
        ...otherProps
    } = props;

    const formatData = useFormatData({ columns, data });
    const tableData = useSearchData({ columns, data: formatData, searchText });

    useEffect(() => {
        if (initCurrentRow && currentRow !== undefined && !tableData?.some((item) => item[rowKey] === currentRow)) {
            onSelectRow?.(tableData[0]?.[rowKey] ?? '');
        }
    }, [tableData, rowKey, currentRow, onSelectRow, initCurrentRow]);

    return (
        <Table
            ref={ref}
            {...otherProps}
            cellEllipsis={false}
            actionGradient={false}
            pageLength={pageLength ?? 100}
            bordered={bordered}
            columns={renderColumns || columns}
            data={tableData}
            rowKey={rowKey}
            currentRow={currentRow}
            onSelectRow={onSelectRow}
        />
    );
});

export default DataTable;
